/* eslint-disable max-len */
import React from 'react';
import { Pane, Flex } from '@leverege/ui-elements';
import ColorOption, { options } from "../../views/color/ColorOption.js";
import S from './ColorEditor.css';
import { jsx as _jsx } from "react/jsx-runtime";
function ColorAttributeValueEditor({
  disabled,
  eventData,
  value,
  onChange
}) {
  const [selected, setSelected] = React.useState(value);
  const onClick = ({
    data
  }) => {
    if (disabled) {
      return;
    }
    onChange({
      data: eventData,
      value: data.value
    });

    // The onChange below autopopulates the color name text fields from the selected color swatch, and needs to switch its data field depending on if its a single vehicle creation or a bulk vehicle edit
    // single vehicle creation is identified by an eventData of 'vehicle.color' while bulk vehicle edit is 'vehicle.color:value'
    const eventDataIdentifier = eventData === 'assetLocators.color' ? 'assetLocators.colorName' : 'assetLocators.colorName:value';
    setTimeout(() => {
      // Use setTimeout with 0 delay to prevent this second onChange from overwriting the first by breaking the immediate succession and allowing the 
      // first onChange to be processed in isolation while ensuring the update is handled in separate execution context
      onChange({
        data: eventDataIdentifier,
        value: data.name
      });
      setSelected(data.value);
    }, 0);
  };
  const renderOption = option => {
    return /*#__PURE__*/_jsx(ColorOption, {
      onClick: onClick,
      option: option,
      selected: option.value === selected
    }, option.value);
  };
  const renderPicker = () => {
    return /*#__PURE__*/_jsx(Pane, {
      children: /*#__PURE__*/_jsx(Flex, {
        wrap: "wrap",
        className: S.flex,
        children: options.map(renderOption)
      })
    });
  };
  return renderPicker();
}
export default {
  name: 'assetLocators.color',
  objectType: 'assetLocators',
  getOptions: usage => {
    return {
      embed: true,
      isRenderer: false
    };
  },
  create: opts => {
    const {
      disabled,
      eventData,
      value,
      onChange
    } = opts;
    return /*#__PURE__*/_jsx(ColorAttributeValueEditor, {
      disabled: disabled,
      eventData: eventData,
      value: value,
      onChange: onChange
    });
  }
};